import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { getPlatformSettings, savePlatformSettings } from '../../actions/chargesSettingsActions';

const Settings = ({ 
  platformSettings: { settings, loading, error, success }, 
  getPlatformSettings, 
  savePlatformSettings 
}) => {
  // Local state to manage the form inputs
    const hId = localStorage.getItem('hospitalCode');

  const [formData, setFormData] = useState({
    id: '',
    payinCharge: '',
    payoutCharge: '',
    platformCharge: '',
  });

  // 1. Fetch the settings when the component first mounts
  // useEffect(() => {
  //   getPlatformSettings();
  // }, [getPlatformSettings]);
 useEffect(() => {
    if (hId) {
      getPlatformSettings(hId); 
    }
  }, [getPlatformSettings, hId]);
  // 2. When the settings data arrives from Redux, update the form's local state
  useEffect(() => {
    if (settings) {
      setFormData({
        id: settings.id || '',
        payinCharge: settings.payinCharge || '',
        payoutCharge: settings.payoutCharge || '',
        platformCharge: settings.platformCharge || '',
      });
    }
  }, [settings]);
  console.log('Current settings in component:', settings);

  // Show success message and reset after 3 seconds
  useEffect(() => {
    if (success) {
      const timer = setTimeout(() => {
        // You might want to refetch settings to get the latest data
        getPlatformSettings(hId);
      }, 3000);
      
      return () => clearTimeout(timer);
    }
  }, [success, getPlatformSettings]);

  // Destructure for easier use in the JSX
  const { id, payinCharge, payoutCharge, platformCharge } = formData;

  // Handles changes in the input fields
  const onChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // Handles the form submission
  const onSubmit = (e) => {
    e.preventDefault();
     const hId = localStorage.getItem('hospitalCode'); 
     if (!hId) {
    alert("Hospital Code not found!");
    return;
  }
    const settingsToSave = {
      id: id, // Include the ID for update operation
      payinCharge: parseFloat(payinCharge),
      payoutCharge: parseFloat(payoutCharge),
      platformCharge: parseFloat(platformCharge),
      hospitalID: localStorage.getItem('hospitalCode')
    };
    savePlatformSettings(settingsToSave);
  };

  return (
    <div>
      <div className="page-wrapper ml-0">
        <div className="content container-fluid">
          {/* Page Header */}
          <div className="page-header">
            <div className="row">
              <div className="col-sm-12">
                <h3 className="page-title">Charge Settings</h3>
                <ul className="breadcrumb">
                  <li className="breadcrumb-item"><Link to="/admin">Dashboard</Link></li>
                  <li className="breadcrumb-item active">Charge Settings</li>
                </ul>
              </div>
            </div>
          </div>
          {/* /Page Header */}
          <div className="row">
            <div className="col-12">
              <div className="card">
                <div className="card-header">
                  <h4 className="card-title">
                    Platform Charge Settings
                    {id && <span className="badge badge-info ml-2">Existing Settings</span>}
                  </h4>
                </div>
                <div className="card-body">
                  {/* Success Message */}
                  {success && (
                    <div className="alert alert-success" role="alert">
                      Settings {id ? 'updated' : 'saved'} successfully!
                    </div>
                  )}
                  
                  <form onSubmit={onSubmit}>
                    <div className="form-group">
                      <label>Rezorpay Charge (%)</label>
                      <input 
                        type="number" 
                        step="0.01"
                        min="0"
                        max="100"
                        placeholder='Enter Rezorpay Charge in %' 
                        className="form-control"
                        name="payinCharge"
                        value={payinCharge}
                        onChange={onChange}
                        required
                      />
                    </div>
                    <div className="form-group">
                      <label>Payout Charge (%)</label>
                      <input 
                        type="number" 
                        step="0.01"
                        min="0"
                        max="100"
                        placeholder='Enter Payout Charge in %' 
                        className="form-control"
                        name="payoutCharge"
                        value={payoutCharge}
                        onChange={onChange}
                        required
                      />
                    </div>
                    <div className="form-group">
                      <label>Platform Charge (%)</label>
                      <input 
                        type="number" 
                        step="0.01"
                        min="0"
                        max="100"
                        placeholder='Enter Platform Charge in %' 
                        className="form-control"
                        name="platformCharge"
                        value={platformCharge}
                        onChange={onChange}
                        required
                      />
                    </div>
                    
                    {/* Hidden field for ID */}
                    <input type="hidden" name="id" value={id} />
                    
                    {/* Display any API errors */}
                    {error && <div className="alert alert-danger mt-3">{`Error: ${error}`}</div>}
                    
                    <button type="submit" className='btn btn-info' disabled={loading}>
                      {loading ? 'Saving...' : id ? 'Update Settings' : 'Save Settings'}
                    </button>
                    
                    {id && (
                      <span className="ml-3 text-muted">
                        <i className="fas fa-info-circle"></i> Updating existing settings
                      </span>
                    )}
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>			
      </div>
    </div>
  );
}

// Map the Redux state to the component's props
const mapStateToProps = (state) => ({
  platformSettings: state.platformSettingsReducer, // Make sure this matches your reducer name
});

// Connect the component to Redux, mapping state and actions to props
export default connect(mapStateToProps, { getPlatformSettings, savePlatformSettings })(Settings);